import { memo } from 'react';
import { useTypingStore } from '../../store/useTypingStore';

interface ResultsSummaryProps {
  onRestart: () => void;
  onNext: () => void;
}

const ResultsSummary = memo(function ResultsSummary({
  onRestart,
  onNext,
}: ResultsSummaryProps) {
  const wpm = useTypingStore((s) => s.wpm);
  const cpm = useTypingStore((s) => s.cpm);
  const accuracy = useTypingStore((s) => s.accuracy);
  const errorCount = useTypingStore((s) => s.errorCount);
  const elapsedMs = useTypingStore((s) => s.elapsedMs);

  const seconds = (elapsedMs / 1000).toFixed(1);

  return (
    <div className="results-overlay">
      <div className="results-card">
        <h2 className="results-title">session complete</h2>

        <div className="results-stats">
          <div className="result-stat result-stat--primary">
            <span className="result-stat-value">{wpm}</span>
            <span className="result-stat-label">words per minute</span>
          </div>
          <div className="result-stat">
            <span className="result-stat-value">{accuracy.toFixed(1)}%</span>
            <span className="result-stat-label">accuracy</span>
          </div>
          <div className="result-stat">
            <span className="result-stat-value">{cpm}</span>
            <span className="result-stat-label">chars per minute</span>
          </div>
          <div className="result-stat">
            <span className="result-stat-value">{errorCount}</span>
            <span className="result-stat-label">errors</span>
          </div>
          <div className="result-stat">
            <span className="result-stat-value">{seconds}s</span>
            <span className="result-stat-label">time</span>
          </div>
        </div>

        <div className="results-actions">
          <button className="btn btn--ghost" onClick={onRestart}>
            restart
          </button>
          <button className="btn btn--primary" onClick={onNext}>
            next snippet
          </button>
        </div>
      </div>
    </div>
  );
});

export default ResultsSummary;
